import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { mediaType } from '@bt-react/constants'
import { PlayInStatus } from '../../../lib/playIn/types'

const getIsAccessPermitted = (state: State, props) :boolean => !props.isLocal ||
  state.config.devicePermissions.some((permission) => permission.kind === 'videoinput')

const getMediaType = (state: State): mediaType => state.room.mediaType
const getPlayInStatus = (state: State) => state.playIn.status
const isSidebarActive = (state: State) => state.layouts.mediaLayout.mediaSidebarActive

export function isVideoButtonDisabled(permission, masked, playing): boolean {
  return !permission || masked || playing
}

export default () => createSelector(
  [getIsAccessPermitted, getMediaType, getPlayInStatus, isSidebarActive],
  (permission, media, playing, sidebarActive
  ) :boolean =>
    isVideoButtonDisabled(
      permission,
      [ mediaType.SLIDES, mediaType.SCREENSHARE ].includes(media) && !sidebarActive,
      (media === mediaType.PLAY_IN && playing === PlayInStatus.PLAYING && !sidebarActive) ||
      (media === mediaType.EVENT_STREAM && !sidebarActive)
    )
)

